import { Operation } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";
import { isReferencedOperationRelationship } from "./isReferencedOperationRelationship";

/**
 * Type guard to check if a value is an Operation.
 *
 * Validates that the object has the required properties of an Operation:
 * - NamedObject properties (name, description?, label?)
 * - id: string
 * - order: number
 * - referencedOperationRelationships?: array (each element passes isReferencedOperationRelationship)
 * - resultPattern?: string
 *
 * @param obj - The value to check.
 * @returns True if the value is an Operation.
 */
export const isOperation = (obj: unknown): obj is Operation => {
  if (!isObjectRecord(obj)) return false;
  if (!isNamedObject(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (typeof obj.order !== "number") return false;

  // Optional: resultPattern must be a string if present
  if (obj.resultPattern !== undefined && typeof obj.resultPattern !== "string") return false;

  // Optional: referencedOperationRelationships must be an array if present,
  // and each element must be a valid ReferencedOperationRelationship
  if (obj.referencedOperationRelationships !== undefined) {
    if (!Array.isArray(obj.referencedOperationRelationships)) return false;
    if (obj.referencedOperationRelationships.some((rel) => !isReferencedOperationRelationship(rel)))
      return false;
  }

  if (!["boolean", "undefined"].includes(typeof obj.denominatorOnly)) return false;

  return true;
};
